import React from "react";
import { Props, Styles } from "react-modal";
import BasedModal from "../BaseModalComponents/BasedModal";
import {
    ButtonContainer,
    Container,
    Content,
    ModalBody,
    Row,
    RowContent,
} from "./addParamsModalStyles";
import ModalHeader from "../BaseModalComponents/Header/ModalHeader";
import ModalFooter from "../BaseModalComponents/Footer/ModalFooter";
import { CustomAntCheckbox } from "components/Checkboxes/checboxStyles";
import { FilterParam } from "utils/ticker-params-handler";

export type AddParamsModalType = "display_settings";

type AdditionalProps = {
    title: string;
    onChoose: (param: any) => void;
    filter_params: FilterParam[];
    onRemove: Function;
    selected_filter_params: FilterParam[];
    onApplyClick: Function;
    type?: AddParamsModalType | undefined;
};

type IProps = Props & AdditionalProps;
export const modalStyles: Styles = {
    overlay: {
        position: "fixed",
        zIndex: 100,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
    content: {
        position: "static",
        display: "flex",
        flexDirection: "row",
        gap: "10px",
        width: "350px",
        padding: 0,
        boxShadow: "0px 0px 5px rgba(49, 69, 49, 0.14)",
        borderRadius: "10px",
    },
};
const scrollStyles = {
    backgroundColor: "#7CBE7B",
    width: "6px",
    borderRadius: "10px",
};

function AddParamsModal({
    filter_params,
    selected_filter_params,
    isOpen,
    style,
    title,
    onRequestClose,
    onApplyClick,
    onChoose,
    onRemove,
    type,
}: IProps) {
    const handleOnChoose = (param: FilterParam) => {
        if (selected_filter_params.some((p) => p.name === param.name)) {
            return handleOnRemove(param);
        }

        if (typeof onChoose === "function") {
            onChoose(param);
        }
    };

    const handleOnRemove = (param: FilterParam) => {
        onRemove(param);
    };

    return (
        <BasedModal
            style={modalStyles}
            isOpen={isOpen}
            onRequestClose={onRequestClose}
        >
            <Container>
                <ModalHeader>
                    <div>{title}</div>
                </ModalHeader>
                <ModalBody
                    style={{
                        padding: "30px",
                    }}
                    thumbSize={60}
                    renderThumbVertical={(props: any) => (
                        <div
                            {...props}
                            style={{
                                ...props.style,
                                ...scrollStyles,
                            }}
                        />
                    )}
                >
                    {Array.isArray(filter_params) &&
                        filter_params.slice().map((param) => (
                            <Row
                                style={{
                                    paddingRight: "7px",
                                }}
                                key={param.name + param.type.toString()}
                            >
                                <RowContent>
                                    <Content>
                                        <div style={{ width: "100%" }}>
                                            {param.name}
                                        </div>
                                        {/*<Input defaultValue={item.value} />*/}
                                    </Content>
                                </RowContent>
                                <ButtonContainer>
                                    <CustomAntCheckbox
                                        checked={selected_filter_params.some(
                                            (p) => p.name === param.name
                                        )}
                                        color={"#7CBE7B"}
                                        onClick={() => handleOnChoose(param)}
                                    />
                                </ButtonContainer>
                            </Row>
                        ))}
                </ModalBody>
                <ModalFooter
                    style={{
                        padding: "24px 15px",
                    }}
                    buttonBoxStyle={{
                        justifyContent: "flex-end",
                    }}
                    applyText="Применить"
                    //@ts-ignore
                    onApplyClick={onApplyClick}
                />
            </Container>
        </BasedModal>
    );
}

export default AddParamsModal;
